import * as Sentry from '@sentry/vue';

/**
 * EN-960: without a user on the event, every Sentry issue reports zero users affected, so a
 * one-user glitch is indistinguishable from a site-wide outage.
 *
 * EN-961 settled the position this has to respect: we send the user ID and nothing else. No
 * email, no username, no IP - `sendDefaultPii: false` in `sentry.js` is what stops Sentry
 * defaulting `ip_address` to `{{auto}}`, and it mirrors `send_default_pii` in `config/sentry.php`.
 *
 * Triage signals that are genuinely useful but are not the user's data - plan tier, organization
 * slug, whether this is one of our own accounts - go on as tags instead, so they are searchable
 * without widening the user object. `internal_user` is derived from the email domain locally;
 * the address itself never leaves the browser.
 */
const INTERNAL_EMAIL_DOMAIN = '@wonsulting.com';

export const syncSentryUser = (user) => {
	try {
		if (!user?.id) {
			Sentry.setUser(null);
			Sentry.setTag('plan', undefined);
			Sentry.setTag('organization', undefined);
			Sentry.setTag('internal_user', undefined);

			return;
		}

		Sentry.setUser({ id: String(user.id) });
		Sentry.setTag('plan', user.current_plan?.name ?? 'free');
		Sentry.setTag('organization', user.organization?.slug ?? user.admin_organization?.slug ?? 'none');
		Sentry.setTag('internal_user', user.email?.endsWith(INTERNAL_EMAIL_DOMAIN) === true);
	} catch (error) {
		// Never let telemetry break authentication.
		console.warn('failed to sync Sentry user', error);
	}
};

export const clearSentryUser = () => syncSentryUser(null);
